import { sendWebsocketMessage } from '../../../../../App';
import { getMarketDataRoute } from '../../marketDataRouting';

export function requestChartData({
  msgId,
  symbol,
  dataSource,
  candleDuration,
  numberOfCandles,
  timeUnit,
  brokerage,
  accountNumber,
}) {
  const route = getMarketDataRoute({
    dataSource,
    brokerage,
    messageType: 'getChart',
    symbol,
  });
  if (!route.valid) {
    return false;
  }
  const normalizedSymbol =
    symbol == null ? '' : String(symbol).trim().toUpperCase();
  // Symbol editing can briefly produce a blank value. Do not send a provider request for it;
  // one-character symbols are valid listed instruments and must remain supported.
  if (!normalizedSymbol) {
    return false;
  }
  const msg = {
    messageType: 'getChart',
    msgId,
    symbol: normalizedSymbol,
    dataSource,
    candleDuration,
    numberOfCandles,
    timeUnit,
    brokerage: route.brokerage,
  };
  if (accountNumber) {
    msg.accountNumber = accountNumber;
  }
  sendWebsocketMessage(msg);
  return true;
}
